"use client";
import React, { useState } from "react";
import Pill from "../common/Pill";
const monthlyPlans = [
  {
    name: "Free Tier",
    price: "$0",
    per: "/month",
    description: "Limited access evaluation",
    features: [
      "Max of 1 agent (draft or published)",
      "Max of 20 conversations per month",
    ],
  },
  {
    name: "Basic Tier",
    price: "$89",
    per: "/month",
    description: "For growing businesses that need more power.",
    features: [
      "Max of 5 agents (draft or published)",
      "Max of 1,500 conversations per month",
    ],
    tag: "Most Popular",
  },
  {
    name: "Premium Tier",
    price: "$249",
    per: "/month",
    description: "Premium tier platform access",
    features: [
      "Unlimited agents (draft or published)",
      "Max of 6000 conversations per month",
    ],
  },
];
const yearlyPlans = [
  {
    name: "Free Tier",
    price: "$0",
    per: "/month",
    description: "Limited access evaluation",
    features: [
      "Max of 1 agent (draft or published)",
      "Max of 20 conversations per month",
    ],
    annualAmount: "$0 billed annually",
  },
  {
    name: "Basic Tier",
    price: "$69.92",
    per: "/month",
    description: "For growing businesses that need more power.",
    features: [
      "Max of 5 agents (draft or published)",
      "Max of 1,500 conversations per month",
    ],
    badge: "Save 21%",
    annualAmount: "$839 billed annually",
    tag: "Most Popular",
  },
  {
    name: "Premium Tier",
    price: "$149.92",
    per: "/month",
    description: "Best value for larger teams.",
    features: [
      "Unlimited agents (drafts or published)",
      "Max of 6000 conversations per month",
    ],
    badge: "Save 40%",
    annualAmount: "$1,799 billed annually",
  },
];
const oneTimePlans = [
  {
    name: "Limited Time Agent",
    price: "$49",
    description: "Single voice agent for a limited amount of time",
    features: [
      "Max of 1 agent (draft or published)",
      "Max of 1,000 conversations",
      "One month access only",
      "Auto-downgrade to Free tier after expiration",
    ],
  },
];

export default function PricingPlans() {
  const [activeTab, setActiveTab] = useState("monthly");

  const getPlans = () => {
    if (activeTab === "yearly") return yearlyPlans;
    if (activeTab === "one-time") return oneTimePlans;
    return monthlyPlans;
  };

  const plans = getPlans();

  return (
      <section className="bg-gradient-to-br from-[#893535] via-[#1a0c0a] to-[#1C1C1C] text-white py-20 px-4">
        <div className="max-w-6xl mx-auto flex flex-col items-center gap-4">
          <Pill text="Simple Pricing" backgroundColor="#FFFFFF1A" />
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-2 text-center">
            Choose the Plan That Fits Your Needs
          </h2>
          <p className="text-gray-400 text-center">
            Transparent, flexible, and affordable. Start free, scale as you
            grow. No hidden fees. Cancel anytime.
          </p>

          <div className="bg-[#FFFFFF1A] p-[10px] w-fit mx-auto rounded-full mt-6">
            <div className="flex flex-row gap-1 md:gap-3 text-white">
              <div
                onClick={() => setActiveTab("monthly")}
                className={`py-[7px] md:py-[10px] px-[17px] md:px-[20px] rounded-full cursor-pointer ${
                  activeTab === "monthly"
                    ? "bg-gradient-to-r from-[#8B000060] via-[#B22222] to-[#FF4D4D]"
                    : "bg-transparent"
                }`}
              >
                <h1>Monthly</h1>
              </div>
              <div
                onClick={() => setActiveTab("yearly")}
                className={`py-[7px] md:py-[10px] px-[17px] md:px-[20px] rounded-full cursor-pointer ${
                  activeTab === "yearly"
                    ? "bg-gradient-to-r from-[#8B000060] via-[#B22222] to-[#FF4D4D]"
                    : "bg-transparent"
                }`}
              >
                <h1>Yearly</h1>
              </div>
              <div
                onClick={() => setActiveTab("one-time")}
                className={`py-[7px] md:py-[10px] px-[17px] md:px-[20px] rounded-full cursor-pointer text-nowrap ${
                  activeTab === "one-time"
                    ? "bg-gradient-to-r from-[#8B000060] via-[#B22222] to-[#FF4D4D]"
                    : "bg-transparent"
                }`}
              >
                <h1>One Time</h1>
              </div>
            </div>
          </div>
        </div>

        {/* Plan Cards */}
        <div className="flex flex-row justify-center mt-10 flex-wrap max-w-6xl mx-auto ">
          {plans.map((plan, idx) => (
            <div
              key={idx}
              className={`relative flex flex-col justify-between rounded-3xl border-[3px] px-6 py-10 shadow-lg bg-white/10 transition-all duration-300 min-h-[480px]
                ${
                  plan.name === "Basic Tier" || plan.name === "Limited Time Agent"
                    ? "border-[#FF4D4D] scale-[1.02]"
                    : "border-white/20"
                }`}
            >
              <div className="flex flex-col h-full">
                <div>
                  <h3
                    className={`text-2xl font-bold mb-2 ${
                      plan.name === "Basic Tier" || plan.name === "Limited Time Agent"
                        ? "bg-gradient-to-r from-[#FF4141] via-[#FFA6B0] to-[#BF8DFF] bg-clip-text text-transparent"
                        : "text-white"
                    }`}
                  >
                    {plan.name}
                  </h3>
                  <p className="text-gray-200 mb-6 text-sm max-w-[200px]">
                    {plan.description}
                  </p>

                  {/* Pricing Section */}
                  <div className="mb-14">
                    <div className="flex flex-row items-center justify-between mb-4">
                      <div>
                        <span className="text-4xl font-bold">{plan.price}</span>
                        {plan.per && (
                          <span className="text-gray-300 text-lg">
                            {plan.per}
                          </span>
                        )}
                      </div>
                    
                    </div>
                    <div className="flex justify-start -ml-1 my-2">
                        {plan.badge && (
                        <div className="bg-[#FFFFFF] px-[10px] py-[4px] text-[14px] rounded-full text-[#494949]">
                          <span>{plan.badge}</span>
                        </div>
                      )}
                      </div>
                    {plan.annualAmount && (
                      <p className="text-sm text-[#D9D9D9] mb-4">
                        {plan.annualAmount}
                      </p>
                    )}
                    {plan.tag && (
                      <div className="w-fit mx-auto bg-[#FFFFFF1A] text-xs uppercase px-3 py-1 rounded-full text-white font-medium shadow-lg">
                        {plan.tag}
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex flex-col gap-3 mt-auto">
                  <span className="text-[#FFFFFF] text-sm font-medium">
                    What's included
                  </span>

                  <ul className="text-left space-y-3">
                    {plan.features.map((feature, i) => (
                      <li
                        key={i}
                        className="flex items-center gap-2 font-light text-gray-200 text-[13px]"
                      >
                        <span
                          className={`w-[18px] h-[18px] flex items-center justify-center text-center border  
                            rounded-full text-[10px] 
                            ${
                              plan.name === "Basic Tier" ||
                              plan.name === "Limited Time Agent"
                                ? "border-green-500 text-green-500"
                                : "border-white"
                            }`}
                        >
                          ✓
                        </span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <a
              href="https://app.agoravoice.ai/pricing"
              target="_blank"
                className={`w-full text-center sm:w-auto mt-4 hover:from-[#B22222] hover:to-[#B22222] text-sm bg-gradient-to-r from-[#B22222] to-[#FF4D4D] font-semibold ${
                  plan.name === "Basic Tier" || plan.name === "Limited Time Agent"
                    ? "border border-white"
                    : ""
                } text-white px-3 py-1.5 rounded-lg`} rel="noreferrer"
              >
                Select Plan
              </a>
            </div>
          ))}
        </div>
      </section>
  );
}
